import { IBasic, IChildProp } from "@intelligence/components/Form/type";

interface IAdditionalColumns extends IBasic {
  // 显示条件，为null时为一直显示
  condition: string | null;
}

interface IColunmn extends IBasic {
  // 显示条件，为null时为一直显示
  condition?: string | null;
  // 位于第几列
  position?: number;
}

interface ISheetChildren {
  // 行展示或者列展示，行展示columns表示表头在第一行，列展示row表示表头在第一列
  type: 'columns' | 'row';
  isFixedColumns: boolean;
  // 在sheet中，第一行一列所在的位置，如A1
  startPosition: string;
  // 附加列，多用于根据某种条件显示某些列
  additionalColumns?: IAdditionalColumns[];
  // 当isFixedColumns为true时才有固定列的配置项
  fixedColumns?: IColunmn[];
  // 当isFixedColumns为false才有，由外部传入，动态参数生成的列
  dynamicColumns?: IColunmn[];
}

interface ISheet {
  // sheet名称
  sheetName: string;
  // 显示条件，为null时为一直显示
  condition?: string | null;
  // sheet中的子表配置
  children: ISheetChildren[];
}

// 下载弹窗的配置
// 注意key如果发生修改，convertDownloadPopupParams方法中映射key要同步修改
const MOBILE_DETAIL_STATS_AND_COUNTRIES_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'dataSource',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    // 首字母为|表示或的关系，以逗号分隔出来的数组取或
    condition: 'additionalFields:segment:activeusers||additionalFields:segment:revenue||additionalFields:segment:downloads',
    children: [{
      enumKey: 'appannie_mobile',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      // 当附加字段里面的source等于appannie时默认选中 
      defaultSelectCondition: 'additionalFields:source:appannie',
    }, {
      enumKey: 'sensortower_mobile',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      defaultSelectCondition: 'additionalFields:source:sensortower',
    }, {
      enumKey: 'ogdb_mobile',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      condition: 'additionalFields:isCalibrated:true',
      defaultSelectCondition: 'additionalFields:source:ogdb',
    }],
  },
  {
    enumKey: 'specialDataSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'au_mobile',
      // 当附加字段里面的segment等于activeusers时默认选中 
      defaultSelectCondition: 'additionalFields:segment:activeusers',
    }, {
      enumKey: 'rv_mobile',
      defaultSelectCondition: 'additionalFields:segment:revenue',
    }, {
      enumKey: 'dl_mobile',
      defaultSelectCondition: 'additionalFields:segment:downloads',
    }, {
      enumKey: 'arpu_mobile',
      defaultSelectCondition: 'additionalFields:segment:revenue',
    }, {
      enumKey: 'mr_mobile',
      defaultSelectCondition:
        'additionalFields:segment:retention—retention_monthly||additionalFields:segment:retention—retention_monthly_sensortower',
    }, {
      enumKey: 'lr_mobile',
      defaultSelectCondition: 'additionalFields:segment:retention—retention_lifetime',
      msgKey: 'dbi_lifetime_retention_tips',
    }, {
      enumKey: 'rp_mobile',
      defaultSelectCondition: 'additionalFields:segment:rpd',
    }, {
      enumKey: 'cr_mobile',
      defaultSelectCondition: 'additionalFields:segment:rpd',
    }, {
      enumKey: 'cd_mobile',
      defaultSelectCondition: 'additionalFields:segment:rpd',
    }, {
      enumKey: 'hw_mobile',
    }, {
      enumKey: 'at_mobile',
    }, {
      enumKey: 'pk_mobile',
    }, {
      enumKey: 'ac_mobile',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGameEngine',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'editionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isEditionAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isByEdition',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'special_dateSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      msgKey: 'dbi_info_mobile_time_settings_info',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:isCoutriesPage:true',
      }, {
        enumKey: 'isByTime',
        enumTargetType: 'downloadDataCalcu',
        msgKey: 'dbi_info_mobile_time_settings_info',
        defaultSelectCondition: 'additionalFields:isCoutriesPage:false',
      }]
    }, {
      enumKey: 'special_dateSettingsByTime',
      enumTargetType: 'downloadMainCategory',
      // 这里的condition要特别注意，subForm的层级要在自己的form中重新开始
      condition: 'special_dateSettings:byTime',
      type: 'checkboxGroup',
      children: [{
        enumKey: 'daily',
        enumTargetType: 'granularity',
        // 当附加字段里面的segment不等于rpd时默认选中，首个单词为!表示取反 
        defaultSelectCondition: '!additionalFields:segment:rpd',
      }, {
        enumKey: 'weekly',
        enumTargetType: 'granularity',
      }, {
        enumKey: 'monthly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:segment:rpd',
      }]
    }, {
      enumKey: 'specialCountrySettring',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const MOBILE_DETAIL_STORERANK_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'dataSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      enumKey: 'appStore',
      enumTargetType: 'platformMobile',
    }, {
      isDefault: true,
      enumKey: 'googlePlay',
      enumTargetType: 'platformMobile',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGameEngine',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'editionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isEditionAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isByEdition',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'dateSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isByCountries',
        enumTargetType: 'downloadDataCalcu',
      }]
    }],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

// 数据源的配置
const SOURCE_CONFIG = {
  appannie: {
    label: 'data.ai',
  },
  sensortower: {
    label: 'Sensor Tower',
  },
  'Facebook Gaming': {
    label: 'Facebook Gaming',
  },
  'YouTube': {
    label: 'YouTube',
  },
  'Twitch': {
    label: 'Twitch',
  },
};

// 指标的配置
const METRIC_CONFIG = {
  au: {
    dataSource: ['appannie', 'sensortower'],
    label: 'DAU',
    value: '',
    hasRatio: true,
  },
  rv: {
    dataSource: ['appannie', 'sensortower'],
    label: 'Revenue',
    value: '',
    hasRatio: true,
  },
  dl: {
    dataSource: ['appannie', 'sensortower'],
    label: 'Downloads',
    value: '',
    hasRatio: true,
  },
  arpu: {
    dataSource: ['appannie', 'sensortower'],
    label: 'ARPU',
    value: '',
    hasRatio: true,
  },
  mr: {
    dataSource: ['appannie', 'sensortower'],
    label: ['D2', 'D3', 'D7', 'D15', 'D31'],
    value: '',
    hasRatio: true,
  },
  lifetimeRetention: {
    dataSource: ['appannie', 'sensortower'],
    label: ['D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D14', 'D30', 'D60', 'D90'],
    value: '',
    hasRatio: false,
  },
  rpd: {
    dataSource: ['appannie', 'sensortower'],
    label: 'RPD',
    value: '',
    hasRatio: false,
  },
  cumulativeRevenue: {
    dataSource: ['appannie', 'sensortower'],
    label: 'Cumulative Revenue',
    value: '',
    hasRatio: false,
  },
  cd: {
    dataSource: ['appannie', 'sensortower'],
    label: 'Cumulative Downloads',
    value: '',
    hasRatio: false,
  },
  hoursWatched: {
    dataSource: ['Facebook Gaming', 'YouTube', 'Twitch'],
    label: 'Hours Watched',
    value: '',
    hasRatio: false,
  },
  airtime: {
    dataSource: ['Facebook Gaming', 'YouTube', 'Twitch'],
    label: 'Airtime',
    value: '',
    hasRatio: false,
  },
  peakCCV: {
    dataSource: ['Facebook Gaming', 'YouTube', 'Twitch'],
    label: 'Peak CCV',
    value: '',
    hasRatio: false,
  },
  avgCCV: {
    dataSource: ['Facebook Gaming', 'YouTube', 'Twitch'],
    label: 'Avg CCV',
    value: '',
    hasRatio: false,
  }
};

/**
 * 根据下载弹窗条件的附加列
 * priority 优先级，当多个命中的时候，列的顺序按照优先级来
 */
const ADDITIONAL_COLUMNS_CONFIG = {
  isByEdition: {
    priority: 4,
    columns: [{
      label: 'Edition Id',
      value: '',
    }, {
      label: 'Edition Name',
      value: '',
    }, {
      label: 'Platform',
      value: '',
    }]
  },
  isDaily: {
    priority: 5,
    columns: [{
      label: 'Date',
      value: '',
    }]
  },
  isWeekly: {
    priority: 5,
    columns: [{
      label: 'Date',
      value: '',
    }]
  },
  isMonthly: {
    priority: 5,
    columns: [{
      label: 'Date',
      value: '',
    }]
  },
  isByCountries: {
    priority: 4,
    columns: [{
      label: 'Region_Chinese',
      value: '',
    }, {
      label: 'Region_English',
      value: '',
    }, {
      label: 'Country_Chinese',
      value: '',
    }, {
      label: 'Country_English',
      value: '',
    }],
  },
  isByRegion: {
    priority: 4,
    columns: [{
      label: 'Region_Chinese',
      value: '',
    }, {
      label: 'Region_English',
      value: '',
    }]
  },
  hasCompany: {
    priority: 3,
    columns: [{
      label: 'Publisher Company Name',
      value: '',
    }, {
      label: 'Publisher Company HQ Name',
      value: '',
    }, {
      label: 'Publisher Parent Company',
      value: '',
    }, {
      label: 'Developer Company Name',
      value: '',
    }, {
      label: 'Developer Company HQ Name',
      value: '',
    }, {
      label: 'Developer Parent Company',
      value: '',
    }]
  },
  hasGenre: {
    priority: 2,
    columns: [{
      label: 'App Annie Main Genre',
      value: '',
    }, {
      label: 'App Annie Sub Genre',
      value: '',
    }]
  },
  hasRelease: {
    priority: 1,
    columns: [{
      label: 'Release Date',
      value: '',
    }]
  },
};

// sheet的配置
const SHEET_CONFIG: ISheet[] = [{
  sheetName: 'Stats',
  condition: 'isTimeAggregated',
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: 'A1',
    additionalColumns: [],
    dynamicColumns: [],
  }]
}, {
  sheetName: 'Lifetime Retention',
  condition: 'lifetimeRetention',
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: 'A1',
    additionalColumns: [{
      label: 'Edition Id',
      value: '',
      condition: null
    }, {
      label: 'Edition Name',
      value: '',
      condition: null
    }],
    dynamicColumns: [],
  }]
}, {
  sheetName: 'Summary',
  condition: null,
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: '',
    additionalColumns: [{
      label: 'Game Name',
      value: '',
      condition: null
    }],
  }, {
    type: 'row',
    isFixedColumns: true,
    startPosition: '',
    fixedColumns: [{
      label: 'Regions/Countries',
      value: '',
    }, {
      label: 'Date Start',
      value: '',
    }, {
      label: 'Date End',
      value: '',
    }, {
      label: 'Game Name',
      value: '',
    }],
  }, {
    type: 'columns',
    isFixedColumns: false,
    startPosition: '',
    dynamicColumns: [],
    additionalColumns: [{
      label: 'Metrics',
      value: 'Metrics',
      condition: null
    }]
  }]
}, {
  sheetName: 'Stats-Daily',
  condition: 'isDaily',
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: '',
    additionalColumns: [],
    dynamicColumns: [],
  }]
}, {
  sheetName: 'Stats-Weekly',
  condition: 'isWeekly',
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: '',
    additionalColumns: [],
    dynamicColumns: [],
  }]
}, {
  sheetName: 'Stats-Monthly',
  condition: 'isMonthly',
  children: [{
    type: 'columns',
    isFixedColumns: false,
    startPosition: '',
    additionalColumns: [],
    dynamicColumns: [],
  }]
}];

export default {
  mobileDetailStatsAndCountries: MOBILE_DETAIL_STATS_AND_COUNTRIES_DOWNLOAD_SET,
  mobileDetailStoreRank: MOBILE_DETAIL_STORERANK_DOWNLOAD_SET
};
